<template>
    <div class="topic-button" @click="gotoPage">
      <img v-if="showImage" class="topic-icon" v-bind:src="imgUrl" v-on:error="imageError"/>
      <span v-bind:class="{'no-image': !showImage}" v-html="topicLabel"></span>
    </div>
</template>

<script>
  import textFormat from '@/utils/textFormat'

  export default {
    name: "topic-button",
    props: ['topic'],
    data () {
      return {
        showImage: true
      }
    },
    computed: {
      imgUrl() {
        return '~@/../static/icons/kit/green/' + this.topic.topic_EN.split(' ').join('_').toLowerCase() + '.svg'
      },
      topicLabel () {
        if (this.$i18n.locale == 'ar'){
          return textFormat.formatParagraphs(this.topic.topic_AR)
        }
        return textFormat.formatParagraphs(this.topic.topic_EN)
      }
    },
    methods: {
      gotoPage (){
        this.$router.push({path: '/kit/'+this.topic.topic_EN})
      },
      imageError () {
        this.showImage = false
      }
    }
  }
</script>

<style scoped>
.topic-button{
  flex: 1 1 46%;
  min-width: 46%;
  max-width: 46%;
  min-height: 130px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 3px 6px #cdcdcd;
  color: #6F6F6F;
  font-size: 18px;
  margin: 2%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  text-transform: capitalize;
  text-align: center;
}
.topic-button span{
  margin: 10px;
}
.topic-button span.no-image {
  margin-top: 105px;
}
.topic-icon{
  margin-top: 20px;
  width: 250px;
  height: 90px;
}

img:after { 
  content: "\f1c5" " " attr(alt);
  font-size: 16px;
  color: rgb(100, 100, 100);
  display: block;
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
}

@media only screen and (min-width: 768px) {
  .topic-button{
    flex: 1 1 23%;
    min-width: 23%;
    max-width: 23%;
    min-height: 180px;
    margin: 1%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopicButton.vue